import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import PopoverClass from "./popover";

const Popover = React.createFactory(PopoverClass);
const { any, string, number, bool, oneOf } = PropTypes;

export default class extends React.Component {
  static displayName = "Tooltip";

  static propTypes = {
    content: any,
    position: string,
    width: number,
    disable: bool,
    color: string,
    event: oneOf(["hover", "click"]),
    type: oneOf(["default", "light", "dark"]),
  };

  static defaultProps = {
    type: "dark",
    event: "hover",
    color: "#42565E",
  };

  handleClose = () => {
    return this.refs.popover.handleClose();
  };

  renderContent = () => {
    return (
      <div
        className={classNames("et--tooltip-trigger--content", `is-${this.props.type}`)}
        style={{ width: this.props.width }}
      >
        {this.props.content}
      </div>
    );
  };

  render() {
    return Popover(
      {
        className: classNames("et--tooltip-trigger", this.props.className),
        event: this.props.event,
        position: this.props.position,
        width: this.props.width,
        style: this.props.style,
        disable: this.props.disable,
        popoverContent: this.renderContent,
        options: {
          arrowSize: 4,
          arrowColor: this.props.color,
          arrowBorderColor: this.props.color,
        },
      },
      <span>{this.props.children}</span>
    );
  }
}
